
// **************************************************************************
// Utililty class used to add a style to a component based on some condition.
// This utility depends on the generic classes found in reusable-classes.scss file
// Pass in the condition (true/false) and the class name.
// **************************************************************************
export function addConditionalClassIf(condition, className)  {
    return condition ? ` ${className} `: '';
};


// WEBPACK FOOTER //
// ./src/utils/addConditionalClassIf.js